import React, { FC, useContext } from 'react'

import FormatCryptoCurrency from './FormatCryptoCurrency'
import FormatUSDCurrency from './FormatUSDCurrency'
import { Text } from './index'
import { PriceDisplayContext } from 'context/PriceDisplayContextProvider'
import { PriceDisplay } from 'utils/priceDisplay'
import { FormatCurrencyProps } from 'types/Currency'

type FormatPriceDisplayCurrencyProps = {
  amount:
    | {
        raw?: string | undefined
        decimal?: number | undefined
        usd?: number | undefined
        native?: number | undefined
      }
    | undefined
  maximumFractionDigits?: number
  decimals?: number
  css?: Parameters<typeof Text>['0']['css']
  textStyle?: Parameters<typeof Text>['0']['style']
  children?: React.ReactNode
}

const FormatPriceDisplayCurrency: FC<
  FormatPriceDisplayCurrencyProps & FormatCurrencyProps
> = ({ amount, maximumFractionDigits = 7, ...restProps }) => {
  const { priceDisplay } = useContext(PriceDisplayContext)

  return (
    <>
      {priceDisplay === PriceDisplay.ETH ? (
        <FormatCryptoCurrency amount={amount?.decimal} {...restProps} />
      ) : (
        <FormatUSDCurrency amount={amount?.usd} {...restProps} />
      )}
    </>
  )
}

export default FormatPriceDisplayCurrency
